module.exports = __webpack_public_path__ + "img/calendar.5e92ef51.svg";